export class GameScene extends Phaser.Scene {
  private background: Phaser.GameObjects.Image;
  private player: Phaser.GameObjects.Image;
  private npc: Phaser.Physics.Arcade.Image;
  private coin: Phaser.Physics.Arcade.Image;
  private distanceBetween: number = 50;
  private bungee: number;
  private speed: number = 200;
  private enableNPC: boolean;
  private npcFollowingText: Phaser.GameObjects.Text;
  private winText: Phaser.GameObjects.Text;
  private centerX: number;
  private centerY: number;
  private miniMap: Phaser.Cameras.Scene2D.Camera;
  private cursors: any; //{up: any, down: any, left: any, right: any}

  constructor() {
    super
      ({
        key: "GameScene"
      });
  }

  preload(): void {
    this.load.image("background", require("/src/assets/games/coinRunner/background2.png"));
    this.load.image("player", require("/src/assets/games/coinRunner/player.png"));
    this.load.image("npc", require("/src/assets/games/coinRunner/player2.png"));
    this.load.image("wall", require("/src/assets/games/endlessRunner/box.png"));
    this.load.image("coin", require("/src/assets/games/coinRunner/coin.png"));
  }

  create(): void {
    this.createCamera();
    this.createBackground();
    this.createCursors();
    this.createNPCFollowingText();
    this.setCenter();
    this.createPlayer();
    this.createNPC();
    this.createObstacles();
    this.createLocation();
    this.createWinText();
  }

  createCamera() {
    this.miniMap = this.cameras.add(this.sys.canvas.width - (1366 / 3), this.sys.canvas.height - (768 / 3), 1366 / 3, 768 / 3).setZoom(.2);
  }

  createBackground() {
    this.background = this.add.image(0, 0, "background");
    this.background.setOrigin(0, 0);
  }

  createCursors() {
    this.cursors = this.input.keyboard.addKeys
      ({
        up: Phaser.Input.Keyboard.KeyCodes.W,
        down: Phaser.Input.Keyboard.KeyCodes.S,
        left: Phaser.Input.Keyboard.KeyCodes.A,
        right: Phaser.Input.Keyboard.KeyCodes.D,
      });
  }

  createNPCFollowingText() {
    this.npcFollowingText = this.add.text(
      16, 16, '',
      {
        fontSize: '20px',
        fill: '#ffffff'
      }
    );
  }

  setCenter() {
    this.centerX = this.sys.canvas.width / 2;
    this.centerY = this.sys.canvas.height / 2;
  }

  createPlayer() {
    this.player = this.physics.add.image(this.centerX + 300, this.centerY, "player");
    this.player.setOrigin(.5, .5);
    this.player.setDisplaySize(32, 32);
  }

  createObstacles() {
    this.createWall(this.centerX, this.centerY - 150, "wall");
    this.createWall(this.centerX, this.centerY + 150, "wall");
    this.createWall(this.centerX - 150, this.centerY, "wall");
    this.createWall(this.centerX + 150, this.centerY, "wall");
  }

  createWall(x: number, y: number, texture: string) {
    var wallObject = this.physics.add.image(x, y, texture);
    wallObject.setOrigin(.5);
    wallObject.setImmovable();
    this.physics.add.collider(this.npc, wallObject);
    this.physics.add.collider(this.player, wallObject);
  }

  createNPC() {
    this.npc = this.physics.add.image(this.centerX - 300, this.centerY, "npc");
    this.npc.setOrigin(.5);
    this.npc.setInteractive();
    this.npc.setDisplaySize(32, 32);
    this.npc.on("pointerdown", (pointer: Phaser.Input.Pointer) => {
      this.enableNPC = !this.enableNPC;
    });
  }

  createLocation() {
    this.coin = this.physics.add.image(
      this.centerX,
      this.centerY,
      "coin");
    this.coin.setOrigin(.5, .5);
    this.coin.setInteractive();
    this.coin.on("pointerdown", () => {
      this.cameras.main.shake(500);
    });
    var shakeText = this.add.text(this.centerX, 30, "Press Coin",
      {
        fontSize: '20px',
        fill: '#ffffff'
      });
    shakeText.setOrigin(.5);
  }

  createWinText() {
    this.winText = this.add.text
      (
      this.coin.x,
      this.coin.y - 50,
      "",
      {
        fontSize: '20px',
        fill: '#ffffff'
      }
      );
    this.winText.setOrigin(.5, .5);
  }

  update(): void {
    this.updatePlayer();
    this.updateNPC();
    this.winCondition();
  }
  updateNPC() {
    this.npc.update();
    //NPC Following Controls
    if (this.enableNPC) {
      //NPC Directional Facing Controls
      if (this.npc.x - this.player.x >= 0) {
        this.npc.setFlipX(true);
      }
      if (this.npc.x - this.player.x < 0) {
        this.npc.setFlipX(false);
      }
      //NPC Distance Determining Controls
      if (Math.abs(this.npc.x - this.player.x) >= this.distanceBetween + this.bungee
        || Math.abs(this.npc.y - this.player.y) >= this.distanceBetween + this.bungee) {
        this.bungee = 0;
        this.physics.moveToObject(this.npc, this.player, this.speed);
      }
      else {
        this.bungee = 25;
        this.npc.setVelocity(0);
      }
      this.npcFollowingText.setText("NPC is Following");
    }
    else {
      this.npc.setVelocity(0);
      this.npcFollowingText.setText("NPC is not Following");
    }
  }
  updatePlayer() {
    this.player.update();
    (this.player.body as any).setVelocityX(0);
    (this.player.body as any).setVelocityY(0);
    if (this.cursors.left.isDown) {
      (this.player.body as any).setVelocityX(-this.speed);
      this.player.setFlipX(true);
    }
    if (this.cursors.right.isDown) {
      (this.player.body as any).setVelocityX(this.speed);
      this.player.setFlipX(false);
    }
    if (this.cursors.up.isDown) {
      (this.player.body as any).setVelocityY(-this.speed);
    }
    if (this.cursors.down.isDown) {
      (this.player.body as any).setVelocityY(this.speed);
    }
  }
  winCondition() {
    if
    (
      Phaser.Geom.Intersects.RectangleToRectangle
        (
        this.npc.getBounds(),
        this.coin.getBounds()
        )
    ) {
      this.winText.setText("I Made it");
      this.enableNPC = false;
    }
    else {
      this.winText.setText("");
    }
  }
}



// WEBPACK FOOTER //
// ./src/games/demos/phaserCameraAnimationDemo/scenes/gameScene.ts